import React, {PureComponent, Fragment} from 'react';
import {toastr} from 'react-redux-toastr';
import {Link} from 'react-router-dom';
import connect from 'react-redux/es/connect/connect';

import BringBusinessForm from '../../components/Forms/BringBusinessForm/BringBusinessForm.jsx';
import DefaultLayout from '../Layout/DefaultLayout.jsx';
import Header from '../../components/Header/Header.jsx';
import SubmitButton from '../../components/Forms/BringBusinessForm/SubmitButton.jsx';

import api from '../../../api.js';
import conf from '../../conf.js';
import {generate} from '../../routes.js';

import './BringBusiness.scss';

class BringBusiness extends PureComponent {
  submit = async (data) => {
    try {
      return (await api.businessOpportunities.post(data));
    } catch (e) {
      toastr.error(`Nous n'avons pas pu recevoir vos éléments, veuillez nous contacter au ${conf.site.phone}`, {timeOut: 0});
      console.warn(e);
    }
  };

  onFormSuccess = (response) => {
    toastr.success(response.data.message);
  };

  render() {
    const title = "Twineeds | Programme Apport d'affaires";
    const description = "Découvrez notre programme en apport d'affaires : recommandez des entreprises, identfiez nous un besoin et générez facilement des revenus complémentaires.";
    const headerBrief = <Fragment>
      <p>
        Vous avez entendu parler d'un besoin chez un client ? Apportez-nous des informations de marché en l'échange de
        <Link
          to={generate({name: 'bring-business-cgu', hash: '#apport-d-affaire'})}
          target="_blank"
          rel="noopener noreferrer">
           &nbsp;30%&nbsp;
        </Link>
        de notre marge !</p>
      <p>
        Le principe est simple : si vous avez entendu parler d'un mandat à pourvoir, donnez nous toutes les
        informations dont vous disposez.
      </p>
      <p>
        Si nous remportons le mandat grâce à vos informations nous vous rémunérons.<br/>
        Voir les détails dans les
        <Link to={generate({name: 'bring-business-cgu'})} target="_blank" rel="noopener noreferrer"> CGU</Link>.
      </p>
    </Fragment>;

    return <DefaultLayout id="bring-business" showSidebarMenu={false} helmet={{title, description}}>
      <Header brief={headerBrief} title="Renseignez-nous en l'échange d'une rémunération !"/>

      <section className="container pb-5">
        <BringBusinessForm
          initialValues={{universe: this.props.currentUniverseId}}
          onSubmit={this.submit}
          onSubmitSuccess={this.onFormSuccess}
        />
        <div className="row mt-1">
          <div className="col-md-12 text-center">
            <SubmitButton className="btn btn-primary ml-auto">Valider</SubmitButton>
          </div>
        </div>
      </section>
    </DefaultLayout>;
  }
}

export default connect(
  state => ({
    currentUniverseId: state?.universe?.currentUniverse?.id ?? state?.universe?.universes?.[0]?.id
  })
)(BringBusiness);
